"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardDailyXpResponseToJSON = exports.RewardDailyXpResponseFromJSONTyped = exports.RewardDailyXpResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function RewardDailyXpResponseFromJSON(json) {
    return RewardDailyXpResponseFromJSONTyped(json, false);
}
exports.RewardDailyXpResponseFromJSON = RewardDailyXpResponseFromJSON;
function RewardDailyXpResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'xpRewarded': !(0, runtime_1.exists)(json, 'xpRewarded') ? undefined : json['xpRewarded'],
    };
}
exports.RewardDailyXpResponseFromJSONTyped = RewardDailyXpResponseFromJSONTyped;
function RewardDailyXpResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'xpRewarded': value.xpRewarded,
    };
}
exports.RewardDailyXpResponseToJSON = RewardDailyXpResponseToJSON;
